import React, { Component }  from 'react';
import { Row, Col, Select, Input, Icon, Button, message, Upload } from 'antd';
import UM from 'UM';
import { QINIU_DOMAIN, getQiniuTokenAPI, addGuideAPI } from '@/API';
import Editor from '@/entry_question_editor/question/common/editor';
import { getToolbars } from '@/utils/questionManageType';
import NewModal from '../modal';
import GuideTemp from '../guide_tml'


// 公参
const { Option, OptGroup } = Select;
const { TextArea } = Input;

class StemTemplate extends Component {
    state = {
        uptoken: '',
    }

    componentDidMount() {
		getQiniuTokenAPI({}).then((res) => {
            const { uptoken } = res.data;
            this.setState({uptoken})
        })
    }
    
    // 段落样式改变
    onStemStyleChange = (value, index) => {
        const { onStemStyleChange } = this.props;
        onStemStyleChange && onStemStyleChange(value, index);
    }

    // 内容输入方式改变
    onContentInputStyleChange = (value, index) => {
        const { onContentInputStyleChange } = this.props;
        onContentInputStyleChange && onContentInputStyleChange(value, index);
    }

    // 修改题干内容 - 公共方法
    onEdittStemList = (obj) => {
        const { onEdittStemList } = this.props;
        onEdittStemList && onEdittStemList(obj)
    }

    // 增加题干
    onAddStem = i => {
        const { optionNum, onOptionChange, stemList, selectStemStyle, contentInputStype } = this.props;
        const num = +optionNum + 1;
        
        // 改变段落个数
        onOptionChange && onOptionChange(num);

        // 注意：数组和富文本编辑器的下标不一样
        setTimeout(() => {
            // 修改列表内容，段落样式，录入方式
            let newStemList = [...stemList];
            let newSelectStyle = [...selectStemStyle];
            let newInputStyle = [...contentInputStype];

            newStemList.splice(i, 0 , {
                textArea: '',
                audio: '',
                img: '',
            });
            newSelectStyle.splice(i, 0, 0);
            newInputStyle.splice(i, 0, 'rich_text');

            // 题干内容后移一位
            for (let j = num-1; j > i; j--) {
                let stemContent = UM.getEditor(`stem_template_${j}`).getContent();
                UM.getEditor(`stem_template_${j+1}`).setContent(stemContent);
            }
            UM.getEditor(`stem_template_${i+1}`).setContent('');

            this.onEdittStemList({
                stemList: newStemList,
                selectStemStyle: newSelectStyle,
                contentInputStype: newInputStyle
            })
        }, 0);
    }

    // 删除题干
    onDelStem = i => {
        const { optionNum, onOptionChange, stemList, selectStemStyle, contentInputStype } = this.props;
        const num = +optionNum - 1;

        if (num <= 0) {
            message.error('最后一个题干不可以删除！');
            return false;
        }

        // 修改列表内容，段落样式，录入方式
        let newStemList = [...stemList];
        let newSelectStyle = [...selectStemStyle];
        let newInputStyle = [...contentInputStype];

        newStemList.splice(i-1, 1);
        newSelectStyle.splice(i-1, 1);
        newInputStyle.splice(i-1, 1);

        // 题干内容向前移动一位
        for (let j = i-1; j < num; j++) {
            let stemContent = UM.getEditor(`stem_template_${j+2}`).getContent();
            UM.getEditor(`stem_template_${j+1}`).setContent(stemContent);
        }

        this.onEdittStemList({
            stemList: newStemList,
            selectStemStyle: newSelectStyle,
            contentInputStype: newInputStyle
        });

        setTimeout(() => {
            onOptionChange && onOptionChange(num);
        }, 0)
        
    }

    // 设置引导语
    onSetGuide = () => {
        this.onEdittStemList({isSetDefaultGuide: true})
    }

    // 取消设置引导语
    onCancelSetGuide = () => {
        this.onEdittStemList({isSetDefaultGuide: false})
    }

    //  确认设置引导语
    onOkSetGuide = () => {
        const { guideList } = this.props;
        for (let i = 0; i< guideList.length; i++) {
            if (guideList[i].content.length < 1) {
                message.error(`分类${i+1}的内容不能为空`);
                return false;
            }
            if (guideList[i].list.length > 0) {
                let list  = guideList[i].list;
                for (let j = 0; j < list.length; j++) {
                    if (list[j].content.length < 1) {
                        message.error(`分类${i+1}的内容${j+1}不能为空`);
                        return false;
                    }
                }
            }
        }
        this.onEdittStemList({isSetDefaultGuide: false});
        // let temp_id = -1; // 新建模版
        // let data = {
        //     temp_id,
        //     list: guideList
        // }
        // addGuideAPI(data).then((res) => {
        //     message.success(res.message)
        // }).catch(err => {
        //     console.log(err)
        // })
    }

    // 使用默认引导语
    onGetGuide = key => {
        this.onEdittStemList({isShowGetGuide: true, guideCurrentStem: key});
    }

    // 确认引用引导语
    onSetGuideText = content => {
        const { stemList, guideCurrentStem } = this.props;
        const NewStemList = [...stemList];
        NewStemList[guideCurrentStem].textArea = content;

        this.onEdittStemList({stemList: NewStemList, isShowGetGuide: false});
    }

    // 取消引用引导语
    onOpenModal = () => {
        this.onEdittStemList({isShowGetGuide: false})
    }

    // 分类内容发生变化
    onClassifyChange = (e, index) => {
        const { guideList } = this.props;
        const newGuideList = [...guideList];
        newGuideList[index].content = e.target.value;

        this.onEdittStemList({guideList: newGuideList});
    }

    // 子分类内容发生变化
    onGuideCntChange = (e, pIndex, cIndex, diff) => {
        const { guideList } = this.props;
        const newGuideList = [...guideList];

        newGuideList[pIndex].list[cIndex][diff] = e.target.value;
        this.onEdittStemList({guideList: newGuideList});
    }

    // 新增/减少分类
    onPChassifyChange = (index, diff) => {
        const { guideList } = this.props;
        const newGuideList = [...guideList];

        if (diff === 'add') {
            newGuideList.splice(index+1, 0, {
                "key_words": "",
                "content": "",
                "list": [
                    {
                        key_words: '',
                        content: ''
                    }
                ]
            });
        }
        else if (diff === 'remove'){
            if (newGuideList.length <= 1) {
                message.error('最后一个分类不能删除！');
                return false;
            }
            newGuideList.splice(index, 1)
        }

        this.onEdittStemList({guideList: newGuideList});
    }

    // 增加/减少子分类
    onCChassifyChange = (pIndex, cIndex, diff) => {
        const { guideList } = this.props;
        const newGuideList = [...guideList];

        if (diff === 'add') {
            newGuideList[pIndex].list.splice(cIndex+1, 0, {
                key_words: '',
                content: ''
            })
        }
        else if (diff === 'remove') {
            if (newGuideList[pIndex].list.length <= 1) {
                message.error('最后一个子分类不能删除！');
                return false;
            }
            newGuideList[pIndex].list.splice(cIndex, 1);
        }

        this.onEdittStemList({guideList: newGuideList}); 
    }
    
    // 改变文本款内容
    handleTextContent = (e, i) => {
        const { stemList } = this.props;
        const newStmList = [...stemList];
        newStmList[i] = Object.assign( {}, newStmList[i], {
           textArea: e.target.value
        });
        this.onEdittStemList({stemList: newStmList});
    }
    // 上传音频成功
    handleUploadChange = (data, i) => {
        const { stemList } = this.props;
        const newStmList = [...stemList];
        if(data.file.status=='uploading'){
            // 上传中
        }else if(data.file.status=='done'){
            // 上传成功
            let fileUrl = `${QINIU_DOMAIN}${data.file.response.key}`;
            newStmList[i] = Object.assign(newStmList[i], {
                audio: fileUrl
            })
            this.onEdittStemList({stemList: newStmList});
        }else {
            // 上传失败
        }
    }

    // 上传图片
    handleUploadImgChange = (data, i) => {
        const { stemList } = this.props;
        const newStmList = [...stemList];
        if(data.file.status=='uploading'){
            // 上传中
        }else if(data.file.status=='done'){
            // 上传成功
            let fileUrl = `${QINIU_DOMAIN}${data.file.response.key}`;
            newStmList[i] = Object.assign(newStmList[i], {
                img: fileUrl
            })
            this.onEdittStemList({stemList: newStmList});
        }else {
            // 上传失败
        }
    }

    //  视频验证
    handleBeforeUpload = file => {
        const isJPG = (file.type === 'audio/mp3'||file.type === 'audio/mpeg');
        const isLt20M = file.size / 1024 / 1024 <= 20;

        if (!isJPG) {
            message.error('音频格式支持mp3');
        }
        
        if (!isLt20M) {
            message.error('音频的最大尺寸不能超过20M');
        }
        return isJPG && isLt20M;
    }

    //  图片验证
    handleBeforeImgUpload = file => {
        const type = ['image/jpeg', 'image/png'];
        const isJPG =  type.includes(file.type);
        if (!isJPG) {
            message.error('支持png、jpg类型');
        }
        return isJPG
    }

    // 渲染输入方式
    renderContent = i => {
        let { contentInputStype, stemList, subject, guideList } = this.props;
        let { uptoken } = this.state;
        let num = contentInputStype[i];

        const uploadProps={
            data:{
                token: uptoken
            },
            action:"//up.qbox.me/",
            showUploadList: false
        }

        return (
            <div className="toggle-input-type">
                <div className="textarea-input" style={{display: num === 'text' ? 'block' : 'none'}}>
                    <TextArea value={stemList[i].textArea} autosize={{ minRows: 2 }} onChange={(e) => this.handleTextContent(e, i)} />
                </div>
                <div className="editor-container"  style={{display: num === 'rich_text' ? 'block' : 'none'}}>
                    <Editor id={`stem_template_${i+1}`}  toolbar={getToolbars(subject,'stem')}/>
                </div>
                <div style={{display: num === 'image' ? 'block' : 'none'}}>
                    <div className="upload-image">
                        <Upload 
                            {...uploadProps}
                                accept="img/*"
                                beforeUpload={this.handleBeforeImgUpload}
                                onChange={data => this.handleUploadImgChange(data, i)}
                            >
                            <div className="upload-img-icon">
                                <Icon type="upload" />
                            </div>
                        </Upload>
                        <span className="accept-type">*&nbsp;支持png、jpg类型</span>
                        <div className="img-display">
                            <img title="预览图片" src={stemList[i].img.length > 0 ? stemList[i].img : 'static/img/default_img.png'} />
                        </div>
                    </div>
                </div>
                <div style={{display: num === 'audio' ? 'block' : 'none'}}>
                    <div className="upload-audio" >
                        <Upload 
                            {...uploadProps}
                                accept="audio/*"
                                beforeUpload={this.handleBeforeUpload}
                                onChange={data => this.handleUploadChange(data, i)}
                            >
                            <div className="upload-audio-icon">
                                <Icon type="upload" />
                            </div>
                        </Upload>
                        <span className="accept-type">*&nbsp;音频格式为mp3，20M上限</span>
                        <div className="audio-display">
                            {
                                stemList[i].audio.length > 0 ? <audio src={stemList[i].audio} controls="controls">您的浏览器不支持</audio> : <Icon type="sound" />
                            }
                        </div>
                    </div>
                </div>   
            </div>
        )
    }

    // 渲染模版
    renderStem = () => {
        const { optionNum, stemStyle, selectStemStyle, contentInputType, contentInputStype, isSetDefaultGuide, guideList, isShowGetGuide, subject } = this.props;
        let stemArr = [];
        for (let i = 1; i <= optionNum; i++) {
            stemArr.push(
                <Row className="content-tml-row-public" type="flex" align="top" key={i}>
                    <Col span={2} className="content-tml-public-name">
                        <p className="stem-name">段落{i}：</p>
                        <p className="stem-icon">
                            <Icon type="plus-circle-o" onClick={() => this.onAddStem(i)} />
                            <Icon type="minus-circle-o" onClick={() => this.onDelStem(i)} />
                        </p>
                    </Col>
                    <Col span={20} className="stem-detail">
                        <div className="stem-group">
                            <div className="select-stem-style">
                                <label>选择段落样式：&nbsp;&nbsp;</label>
                                <Select 
                                    style={{width: '140px'}}
                                    value={selectStemStyle[i-1] === 0 ? '' : selectStemStyle[i-1]}
                                    onChange={value => this.onStemStyleChange(value, i-1)}
                                >
                                    {
                                        stemStyle.length > 0 && stemStyle.map((item, index) => 
                                            <Option value={item.type_style} key={index}>{item.type_name}</Option>
                                        )
                                    }
                                </Select>
                            </div>
                            <div className="content-in-style">
                                <label>内容录入方式：&nbsp;&nbsp;</label>
                                <Select 
                                    style={{width: '140px'}}
                                    value={contentInputStype[i-1]}
                                    onChange={value => this.onContentInputStyleChange(value, i-1)}
                                >
                                    {
                                        contentInputType(selectStemStyle[i-1]).length > 0 && contentInputType(selectStemStyle[i-1]).map((item, index) => 
                                            <Option value={item.text} key={index}>{item.name}</Option>
                                        )
                                    }
                                </Select>
                            </div>
                            {
                                selectStemStyle[i-1] === 'english_guide' ? <Button className="set-default-guide" type="primary" style={{marginRight: '20px'}} onClick={this.onSetGuide}>设置默认引导语</Button> : null
                            }
                            {
                                selectStemStyle[i-1] === 'english_guide' ? <Button className="set-default-guide" type="primary" onClick={() => this.onGetGuide(i-1)}>使用默认引导语</Button> : null
                            }
                        </div>
                        {
                            this.renderContent(i-1)
                        }
                    </Col>
                </Row>
            );
        }

        return (
            <div>
                {stemArr}
                <NewModal
                    isSetDefaultGuide={isSetDefaultGuide}
                    guideList={guideList}
                    onOkSetGuide={this.onOkSetGuide}
                    onCancelSetGuide={this.onCancelSetGuide}
                    onClassifyChange={this.onClassifyChange}
                    onGuideCntChange={this.onGuideCntChange}
                    onPChassifyChange={this.onPChassifyChange}
                    onCChassifyChange={this.onCChassifyChange}
                >
                </NewModal>
                <GuideTemp
                    isShowGetGuide={isShowGetGuide}
                    setGuideText={this.onSetGuideText}
                    openModal={this.onOpenModal}
                    guideList={guideList} />
            </div>
        )
    }
    render() {
        return (
            this.renderStem()
        )
    }
}

export default StemTemplate;


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/components/stem_editor/stem.js